module.exports = __webpack_public_path__ + "img/2026-10-11b_1.0f8402a3.jpg";